module.exports = __webpack_public_path__ + "img/404.90c72b42.png";